"use strict";
// We can't define the type of this variable,
// see: https://github.com/ajv-validator/ajv/issues/1521
exports.__esModule = true;
var ajv_1 = require("ajv");
var regexSchema_1 = require("./regexSchema");
var selectorSchema_1 = require("./selectorSchema");
var rawConfigSchema_1 = require("./rawConfigSchema");
var CLASSES = { Function: Function };
var ajv = new ajv_1["default"]();
// ajv.addKeyword({
//   keyword: 'function',
//   validate: function (data) {
//     return typeof data === 'function';
//   }
// });
ajv.addKeyword({
    keyword: 'instanceof',
    compile: function (schema) { return function (data) { return data instanceof CLASSES[schema]; }; }
});
ajv.addSchema([regexSchema_1["default"], rawConfigSchema_1["default"], selectorSchema_1["default"]]);
exports["default"] = ajv.compile(rawConfigSchema_1["default"]);
